import { Input } from 'antd';
import type { InputProps } from 'antd';
import { SearchOutlined } from '@ant-design/icons';
import s from './SearchInput.module.scss';

type Props = InputProps;

export function SearchInput({ prefix, className, ...rest }: Props) {
  return (
    <Input {...rest} prefix={prefix ?? <SearchOutlined />} className={[s.root, className].filter(Boolean).join(' ')} />
  );
}
